import {
  DOSSIER_GATE_REQUIRED_FIELDS,
  DOSSIER_PRIMARY_WORKFLOW_FIELD,
} from '../core/contracts.js'

export type GateTranslator = (key: string, options?: Record<string, string>) => string

const REQUIRED_LABEL_KEYS = {
  workflow: 'toast.reportMissingWorkflow',
  pain: 'toast.reportMissingPain',
  evidence: 'toast.reportMissingEvidence',
} as const satisfies Record<(typeof DOSSIER_GATE_REQUIRED_FIELDS)[number], string>

const FIELD_LABEL_KEYS: Readonly<Record<string, string>> = {
  ...REQUIRED_LABEL_KEYS,
  [DOSSIER_PRIMARY_WORKFLOW_FIELD]: 'toast.reportMissingPrimaryWorkflow',
}

/** Visitor status line when PDF prepare is blocked. Locale comes from `t`. */
export function formatReportGateToast(t: GateTranslator, missing: readonly string[]): string {
  const fields = missing
    .map(field => FIELD_LABEL_KEYS[field])
    .filter((key): key is string => Boolean(key))
    .map(key => t(key))
    .filter(label => label.length > 0 && !label.startsWith('toast.'))

  if (fields.length === 0) return t('toast.reportIncompleteShort')
  return t('toast.reportIncomplete', { fields: fields.join(', ') })
}

export class ReportDossierGateError extends Error {
  readonly missing: readonly string[]

  constructor(missing: readonly string[]) {
    super('DOSSIER_INCOMPLETE')
    this.name = 'DossierGateError'
    this.missing = missing
  }
}

export function readGateMissing(value: unknown): string[] {
  if (!Array.isArray(value)) return []
  return value.filter((item): item is string => typeof item === 'string' && item.trim().length > 0)
}
